import PortfolioPage from './components/PortfolioPage';

function App() {
  return <PortfolioPage />;
}

export default App;
